// extracted by mini-css-extract-plugin
module.exports = {"solverContainer":"page-main_solverContainer_eZSyM","solverContent":"page-main_solverContent_3hjJN"};